// extracted by mini-css-extract-plugin
export default {"SendNotificationModalContainer":"SendNotification_SendNotificationModalContainer__7VI1z"};